export default "__VITE_ASSET__yyLIV4aj__"